module.exports = __webpack_public_path__ + "media/images/badges/land-stewardship-100-3df1beacb4ba4fdfda7d8fb38ed5ae9a.svg";